export const CURRENT_TOS_VERSION = 'v2026-10-12';
